import React from "react";

const CommentIcon = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={size}
      height={size}
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <g
          xmlns="http://www.w3.org/2000/svg"
          id="_x33_40_x2C__Bubble_x2C__chat_x2C__comment"
        >
          <g>
            <path
              d="m179.776 229.061c-14.854 0-26.938 12.085-26.938 26.939s12.084 26.938 26.938 26.938 26.938-12.085 26.938-26.938c0-14.854-12.084-26.939-26.938-26.939zm0 33.877c-3.826 0-6.938-3.112-6.938-6.938s3.113-6.939 6.938-6.939 6.938 3.113 6.938 6.939-3.112 6.938-6.938 6.938z"
              fill="#ffffff"
              data-original="#000000"
            />
            <path
              d="m256 229.061c-14.854 0-26.939 12.085-26.939 26.939s12.085 26.938 26.939 26.938c14.853 0 26.937-12.085 26.937-26.938.001-14.854-12.083-26.939-26.937-26.939zm0 33.877c-3.827 0-6.939-3.112-6.939-6.938s3.113-6.939 6.939-6.939c3.825 0 6.937 3.113 6.937 6.939s-3.112 6.938-6.937 6.938z"
              fill="#ffffff"
              data-original="#000000"
            />
            <path
              d="m332.225 229.061c-14.854 0-26.939 12.085-26.939 26.939s12.085 26.938 26.939 26.938 26.938-12.085 26.938-26.938c-.001-14.854-12.085-26.939-26.938-26.939zm0 33.877c-3.826 0-6.939-3.112-6.939-6.938s3.113-6.939 6.939-6.939c3.825 0 6.938 3.113 6.938 6.939s-3.113 6.938-6.938 6.938z"
              fill="#ffffff"
              data-original="#000000"
            />
            <path
              d="m256 36c-121.588 0-220 98.396-220 220 0 59.994 24.399 117.028 67.366 158.426l-63.031 43.334c-3.61 2.481-5.184 7.023-3.885 11.206 1.3 4.183 5.17 7.034 9.55 7.034h210c121.587 0 220-98.396 220-220 0-121.587-98.396-220-220-220zm0 420h-177.802l46.897-32.242c5.408-3.717 5.825-11.563.842-15.833-44.445-38.089-69.937-93.463-69.937-151.925 0-110.28 89.72-200 200-200s200 89.72 200 200-89.72 200-200 200z"
              fill="#ffffff"
              data-original="#000000"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CommentIcon;
